import React, {useEffect, useState} from 'react';
import {Button, Form, FormControl, FormLabel, Modal} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {SETTINGS_APP, SETTINGS_GENERAL} from "../../Constants";

const ManageSettingModal = ({title, settingToEdit, active, onCancel, onConfirm}) => {
    const {t} = useTranslation()

    const [category, setCategory] = useState(SETTINGS_APP)
    const [type, setType] = useState('String')
    const [key, setKey] = useState('')
    const [value, setValue] = useState('')
    const [displayName, setDisplayName] = useState('')
    const [description, setDescription] = useState('')

    useEffect(() => {
        if(settingToEdit)
        {
            setKey(settingToEdit.key)
            setCategory(settingToEdit.category)
            setValue(settingToEdit.value)
            setDisplayName(settingToEdit.displayName)
            setDescription(settingToEdit.description)

            if(settingToEdit.type)
            {
                setType(settingToEdit.type)
            }
        }

    }, [settingToEdit]);

    const settingTypes = ['String', 'Integer', 'Decimal', 'Boolean', 'DateTime', 'TimeSpan']

    function handleConfirm()
    {
        let convertedValue = value
        if(type === 'Integer')
        {
            convertedValue = parseInt(value)
        }
        if(type === 'Decimal')
        {
            convertedValue = parseFloat(value)
        }
        if(type === 'Boolean')
        {
            convertedValue = value.toString().toLowerCase() === 'true'
        }
        if(type === 'DateTime')
        {
            convertedValue = new Date(value).toISOString()
        }


        onConfirm({
            category,
            type,
            key,
            value: convertedValue,
            displayName,
            description
        })
    }

    function handleTypeChange(e)
    {
        setType(e.target.value)
    }

    function inputIsValid()
    {
        if(!category || !type || !key || !value)
        {
            return false
        }

        if(key.trim().length < 1 || value.toString().trim().length < 1)
        {
            return false;
        }


        return valueTypeIsValid()
    }

    function valueTypeIsValid()
    {
        if(type === 'Integer' && isNaN(parseInt(value)))
        {
            return false
        }
        if(type === 'Decimal' && isNaN(parseFloat(value)))
        {
            return false
        }
        if(type === 'Boolean' && !['true', 'false'].includes(value.toString().toLowerCase()))
        {
            return false
        }
        if(type === 'DateTime' && isNaN(Date.parse(value)))
        {
            return false
        }

        return !(type === 'TimeSpan' && !/^\d{1,2}:\d{2}:\d{2}$/.test(value));
    }

    function handleValueChange(e)
    {
        setValue(e.target.value)
    }

    return (
        <Modal centered show={active} onHide={onCancel}>
            <Modal.Header className='modal-header' closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={'d-flex justify-content-between align-items-center'}>
                    <div className={'w-100 px-1'}>
                        <FormLabel>Category</FormLabel>
                        <Form.Select value={category} onChange={(e) => {setCategory(e.target.value)}}>
                            <option value={SETTINGS_APP}>App</option>
                            <option value={SETTINGS_GENERAL}>General</option>
                        </Form.Select>
                    </div>
                    <div className={'w-100 px-1'}>
                        <FormLabel>Type</FormLabel>
                        <Form.Select value={type} onChange={handleTypeChange}>
                            {settingTypes.map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>

                <FormLabel className={'mt-3'}>Key</FormLabel>
                <FormControl type='text' placeholder='UNIQUE_KEY' value={key} onChange={(e) => {setKey(e.target.value)}}/>

                <FormLabel className={'mt-3'}>Value</FormLabel>
                <FormControl type='text' placeholder='Value' value={value} onChange={handleValueChange}/>

                <FormLabel className={'mt-3'}>Display Name</FormLabel>
                <FormControl type='text' placeholder='Setting XYZ' value={displayName} onChange={(e) => setDisplayName(e.target.value)}/>

                <FormLabel className={'mt-3'}>Description</FormLabel>
                <FormControl as='textarea' rows={2} style={{maxHeight: "150px"}} placeholder='Description of the setting' value={description} onChange={(e) => setDescription(e.target.value)}/>

            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant={'success'}
                    onClick={handleConfirm}
                    disabled={!inputIsValid()}>
                    {t('global.operations.confirm')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ManageSettingModal;